module.exports = "<div class=\"chart-container\" (window:resize)=\"onResize($event)\">\n  <div class=\"chart\" #chart></div>\n  <div *ngIf=\"isLoading\" class=\"loading\">\n    <img src=\"assets/icons/loading-on-white.gif\"/>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/chart-legend/chart-legend.component.html
// module id = ./src/app/projects/project/chart-legend/chart-legend.component.html
// module chunks = main